import { takeLatest, call, put } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { api } from "../api";
import { showToast } from "../../../../utils/showToast";

export const SET_LOADING = "saga/chains/SET_LOADING";

export const FETCH_CHAINS_SUCCESS = "saga/chains/FETCH_CHAINS_SUCCESS";

export const ADD_CHAIN = "saga/chains/ADD_CHAIN";

export const EDIT_CHAIN = "saga/chains/EDIT_CHAIN";
export const EDIT_CHAIN_SUCCESS = "saga/chains/EDIT_CHAIN_SUCCESS";

export const FETCH_CURRENT_USER = "saga/chains/FETCH_CURRENT_USER";

export const RESET_FILTERS = "saga/chains/RESET_FILTERS";
export const SET_ERROR = "saga/chains/SET_ERROR";
export const SET_STATUS = "saga/chains/SET_STATUS";

const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),

  createChain: createAction(ADD_CHAIN),
  changeChain: createAction(EDIT_CHAIN),
  resetFilters: createAction(RESET_FILTERS)
};

export const { fetchCurrentUser, createChain, changeChain, resetFilters, makeDefault } =
  actionCreators;

export default function* watchChains() {
  yield takeLatestSafe(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatestSafe(ADD_CHAIN, addChain);
  yield takeLatestSafe(EDIT_CHAIN, editChain);
}

function takeLatestSafe(action, effect) {
  return takeLatest(action, tryCatch(effect));
}

function tryCatch(effect) {
  return function* (args) {
    try {
      yield call(effect, args);
    } catch (err) {
      console.error(err);
      if (err.response.status === 422) {
        yield put({ type: SET_ERROR, payload: err.response.data });
      }
    }
  };
}

function* getCurrentUserData() {
  yield put({ type: SET_LOADING, payload: true });

  const { data: list } = yield call(api.getChains);

  const { data: settings } = yield call(api.getSettings);

  yield put({
    type: FETCH_CHAINS_SUCCESS,
    payload: { list, settings }
  });

  yield put({ type: SET_LOADING, payload: false });
}

function* addChain(data) {
  yield put({ type: SET_STATUS, payload: "pending" });
  let { organization_id, active_store_statuses, ...rest } = data.payload;

  let statuses = active_store_statuses.map((el) => el.id);

  const {
    data: { message }
  } = yield call(api.addChain, {
    clubready_chain: {
      organization_id: organization_id.id,
      ...(active_store_statuses.length > 0 ? { active_store_statuses: statuses } : []),

      ...rest
    }
  });

  showToast(message);

  yield put({ type: SET_STATUS, payload: "success" });
}

function* editChain(data) {
  yield put({ type: SET_STATUS, payload: "pending" });

  let { data: info, dirtyFields, id, orgName } = data.payload;

  let fields = Object.keys(dirtyFields);

  let formattedDataForRequest = {};

  fields.forEach((key) => {
    formattedDataForRequest[key] = info[key];
  });

  let { active_store_statuses, ...rest } = formattedDataForRequest;

  yield call(api.updateChain, id, {
    clubready_chain: {
      ...(active_store_statuses
        ? { active_store_statuses: active_store_statuses.map((el) => el.id) }
        : []),
      ...rest
    }
  });

  if (rest.name) {
    yield put({
      type: EDIT_CHAIN_SUCCESS,
      payload: { id, name: rest.name, orgName }
    });
  }

  yield put({ type: SET_STATUS, payload: "success" });

  yield put({
    type: RESET_FILTERS
  });
}
